import moment from "moment";

export function dateFormatter(since, period, index) {
  const date = moment(since);
  if (period === 'All time') {
    const yesterday = moment().add(-1, 'days');
    const delta = yesterday.diff(date, 'days') / 51;
    date.add(index * delta, 'days');
  } else if (period === '365 d') {
    date.add(index + 1, 'weeks').add(-1, 'days');
  } else {
    date.add(index, 'days');
  }
  return date.format("D MMM, YYYY");
}